/*
###################################################################
Fitinsur Open Insurance - Copyright 2019-2023 - All Rights Reserved
###################################################################
*/

/* eslint-disable react-hooks/rules-of-hooks */
/* eslint-disable no-unused-expressions */

function handleInitialAdjustments({
  questionnaire,
}) {
  return questionnaire.map(question => {
    if ([1444].includes(question.idQuestion)) {
      question.behaviorObject.isRequired = questionnaire.find(question => question.idQuestion === 175)?.idAnswerOption === 6893;
      const deductionDimension = question.childrenQuestions?.find(question => question.idQuestion === 1513);
      const { defaultValue } = deductionDimension?.behaviorObject || {};

      for (const q of question.childrenQuestions || []) {
        q.visibleQuestion = true;
        q.behaviorObject.isRequired = questionnaire.find(question => question.idQuestion === 175)?.idAnswerOption === 6893;

        if (q.idQuestion === 1445 || q.idQuestion === 1511) {
          q.behaviorObject.isRequired = deductionDimension?.idAnswerOption ? deductionDimension?.idAnswerOption === 7091 : defaultValue === 7091;
          q.visibleQuestion = deductionDimension?.idAnswerOption ? deductionDimension?.idAnswerOption === 7091 : defaultValue === 7091;
        }

        if (q.idQuestion === 1446) {
          q.behaviorObject.isRequired = deductionDimension?.idAnswerOption ? deductionDimension?.idAnswerOption === 7092 : defaultValue === 7092;
          q.visibleQuestion = deductionDimension?.idAnswerOption ? deductionDimension?.idAnswerOption === 7092 : defaultValue === 7092;
        }
      }

      for (const q of questionnaire) {
        const deductionDimension = questionnaire.find(question => question.idQuestion === 1513);
        const { defaultValue } = deductionDimension?.behaviorObject || {};

        if (q.idQuestion === 1445 || q.idQuestion === 1511) {
          q.behaviorObject.isRequired = deductionDimension?.idAnswerOption ? deductionDimension?.idAnswerOption === 7091 : defaultValue === 7091;
          q.visibleQuestion = deductionDimension?.idAnswerOption ? deductionDimension?.idAnswerOption === 7091 : defaultValue === 7091;
        }

        if (q.idQuestion === 1446) {
          q.behaviorObject.isRequired = deductionDimension?.idAnswerOption ? deductionDimension?.idAnswerOption === 7092 : defaultValue === 7092;
          q.visibleQuestion = deductionDimension?.idAnswerOption ? deductionDimension?.idAnswerOption === 7092 : defaultValue === 7092;
        }
      }
    }

    return question;
  })
};

async function handleQuestionChange({
  question,
  value,
  questionnaireUpdated,
  setQuestionnaireUpdated,
  setFieldValue,
}) {
  try {
    let saveQuestionnaire = false;

    if (question.idQuestion === 1513) {
      saveQuestionnaire = true;
      const { idAnswerOption } = value;


      questionnaireUpdated = questionnaireUpdated.map(qst => {
        if (qst.idQuestion === 1445 || qst.idQuestion === 1511) {
          qst.visibleQuestion = idAnswerOption === 7091;
          qst.behaviorObject.isRequired = idAnswerOption === 7091;
        }

        if (qst.idQuestion === 1446) {
          qst.visibleQuestion = idAnswerOption === 7092;
          qst.behaviorObject.isRequired = idAnswerOption === 7092;
        }

        return qst;
      })
    }

    if (saveQuestionnaire) setQuestionnaireUpdated(questionnaireUpdated);

  } catch (e) {
    console.log('BROKER_REMUNERATION_DEDUCTION - handleQuestionChange - error', e)
  }
};

function handleQuestionBlur({
  question,
  value,
  setFieldValue,
  formikRef,
  obligorGroup,
  setObligorGroup,
  index,
  values,
  setMaxValuePerc,
  mask,
  maskPercentage,
}) {
  try {

  } catch (e) {
    console.log("BROKER_REMUNERATION_DEDUCTION - handleQuestionBlur error", e)
  }
}

async function handleRequestSerproCnpj({
  question: rootQuestion,
  data,
  questionnaire,
  setQuestionnaire,
  setFieldValue,
}) {
  try {
    questionnaire = questionnaire.map(question => {

      return question;
    })

    setQuestionnaire(questionnaire);
  } catch (e) {
    console.log('BROKER_REMUNERATION_DEDUCTION - handleRequestSerproCnpj - error', e)
  }
};

const events = {
  handleInitialAdjustments,
  handleQuestionChange,
  handleQuestionBlur,
  handleRequestSerproCnpj,
};

export { events };